/**
 * Lake house LP API
 *
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { Pair } from './pair';

/**
 * Trade DTO
 */
export interface TradeDto {
  id?: number;
  orderId?: number;
  pair?: Pair;
  timestamp?: string;
  counterpartyName?: string;
  counterpartyType?: TradeDto.CounterpartyTypeEnum;
  tradeQty?: number;
  clientExecPrice?: number;
  referencePrice?: number;
  hedgedQty?: number;
  baseAssetHedgedQty?: number;
  quoteAssetHedgedQty?: number;
  side?: TradeDto.SideEnum;
}
export namespace TradeDto {
  export const CounterpartyTypeEnum = {
    Account: 'ACCOUNT',
    LiquidityProvider: 'LIQUIDITY_PROVIDER',
  } as const;
  export type CounterpartyTypeEnum = (typeof CounterpartyTypeEnum)[keyof typeof CounterpartyTypeEnum];
  export const SideEnum = {
    Buy: 'BUY',
    Sell: 'SELL',
  } as const;
  export type SideEnum = (typeof SideEnum)[keyof typeof SideEnum];
}
